import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function AppLayout({ children }: Props) {
  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <div className="max-w-5xl mx-auto p-4 space-y-4">{children}</div>
    </div>
  );
}
